/* Zorlyftplaza theme — motion + AJAX cart + editor-safe re-init */
(function () {
    'use strict';

    /* ---------- Lenis smooth scroll ---------- */
    function initLenis() {
        if (typeof Lenis === 'undefined') return;
        var lenis = new Lenis({ lerp: 0.09 });
        function raf(time) {
            lenis.raf(time);
            requestAnimationFrame(raf);
        }
        requestAnimationFrame(raf);
    }
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initLenis);
    } else {
        initLenis();
    }

    /* ---------- Scroll reveals (re-scans dynamically added sections) ---------- */
    var revealObserver = new IntersectionObserver(
        function (entries) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    entry.target.classList.add('revealed');
                    revealObserver.unobserve(entry.target);
                }
            });
        },
        { threshold: 0.08, rootMargin: '0px 0px -40px 0px' }
    );

    function scanReveals(root) {
        (root || document).querySelectorAll('.reveal:not(.revealed), .reveal-x:not(.revealed)').forEach(function (el) {
            revealObserver.observe(el);
        });
    }

    /* ---------- Spotlight cursor tracking + quick add (re-bindable) ---------- */
    function bindDynamic(root) {
        (root || document).querySelectorAll('.spotlight-card:not([data-zlp-bound])').forEach(function (card) {
            card.setAttribute('data-zlp-bound', '1');
            card.addEventListener('mousemove', function (e) {
                var rect = card.getBoundingClientRect();
                card.style.setProperty('--mx', e.clientX - rect.left + 'px');
                card.style.setProperty('--my', e.clientY - rect.top + 'px');
            });
        });
        (root || document).querySelectorAll('[data-quick-add]:not([data-zlp-bound])').forEach(function (btn) {
            btn.setAttribute('data-zlp-bound', '1');
            btn.addEventListener('click', function (e) {
                e.preventDefault();
                e.stopPropagation();
                window.zlpAddToCart(btn.getAttribute('data-variant'), 1, true);
            });
        });
        (root || document).querySelectorAll('[data-slider-wrap]:not([data-zlp-bound])').forEach(function (wrap) {
            wrap.setAttribute('data-zlp-bound', '1');
            var slider = wrap.querySelector('[data-slider]');
            wrap.querySelectorAll('[data-slide]').forEach(function (btn) {
                btn.addEventListener('click', function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    if (slider) {
                        slider.scrollBy({ left: parseInt(btn.getAttribute('data-slide'), 10) * slider.clientWidth, behavior: 'smooth' });
                    }
                });
            });
        });
        (root || document).querySelectorAll('[data-tilt]:not([data-zlp-tilt-bound])').forEach(function (stage) {
            stage.setAttribute('data-zlp-tilt-bound', '1');
            var strength = parseFloat(stage.getAttribute('data-tilt')) || 0;
            if (!strength || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
            stage.addEventListener('pointermove', function (e) {
                var rect = stage.getBoundingClientRect();
                var x = (e.clientX - rect.left) / rect.width - 0.5;
                var y = (e.clientY - rect.top) / rect.height - 0.5;
                stage.style.setProperty('--tilt-x', (-y * strength).toFixed(2) + 'deg');
                stage.style.setProperty('--tilt-y', (x * strength).toFixed(2) + 'deg');
            });
            stage.addEventListener('pointerleave', function () {
                stage.style.setProperty('--tilt-x', '0deg');
                stage.style.setProperty('--tilt-y', '0deg');
            });
        });
    }

    scanReveals(document);
    bindDynamic(document);

    new MutationObserver(function (mutations) {
        var dirty = false;
        mutations.forEach(function (m) {
            if (m.addedNodes.length) dirty = true;
        });
        if (dirty) {
            scanReveals(document);
            bindDynamic(document);
        }
    }).observe(document.body, { childList: true, subtree: true });

    document.addEventListener('shopify:section:load', function (e) {
        scanReveals(e.target || document);
        bindDynamic(e.target || document);
    });

    /* ---------- Hero parallax ---------- */
    function bindParallax() {
        var parallaxEls = document.querySelectorAll('[data-parallax]');
        if (!parallaxEls.length) return;
        window.addEventListener(
            'scroll',
            function () {
                var y = window.scrollY;
                parallaxEls.forEach(function (el) {
                    var speed = parseFloat(el.getAttribute('data-parallax')) || 0.2;
                    el.style.transform = 'translateY(' + y * speed + 'px)';
                });
            },
            { passive: true }
        );
    }
    bindParallax();

    /* ---------- Mobile menu ---------- */
    var menuToggle = document.querySelector('[data-menu-toggle]');
    var mobileMenu = document.getElementById('MobileMenu');
    if (menuToggle && mobileMenu) {
        menuToggle.addEventListener('click', function () {
            mobileMenu.classList.toggle('hidden');
        });
        mobileMenu.querySelectorAll('a').forEach(function (link) {
            link.addEventListener('click', function () {
                mobileMenu.classList.add('hidden');
            });
        });
    }

    /* ---------- Cart drawer ---------- */
    var drawer = document.getElementById('CartDrawer');
    var overlay = document.getElementById('CartOverlay');
    var FREE_SHIP = window.ZLP_FREE_SHIP || 199900; // cents
    var EMPTY_TEXT = window.ZLP_EMPTY_TEXT || 'Cart is empty — go cop something';
    var BUNDLE_CODES = {};
    (window.ZLP_BUNDLE_CODES_RAW || '').split('\n').forEach(function (line) {
        var parts = line.split('=');
        if (parts.length === 2) BUNDLE_CODES[parts[0].trim()] = parts[1].trim();
    });

    function bundleDiscountCode(cart) {
        var maxDisc = 0;
        var setCount = 0;
        cart.items.forEach(function (item) {
            if (!item.properties) return;
            var isSet = false;
            Object.keys(item.properties).forEach(function (k) {
                if (k === 'Outfit set' && item.properties[k]) isSet = true;
                var m = /(\d+)\s*%/.exec(item.properties[k] || '');
                if (m) maxDisc = Math.max(maxDisc, parseInt(m[1], 10));
            });
            if (isSet) setCount += 1;
        });
        // Multi-product outfit set tiers: 2 items −10%, 3–4 items −15%, 5+ items −20%
        var setDisc = setCount >= 5 ? 20 : setCount >= 3 ? 15 : setCount === 2 ? 10 : 0;
        maxDisc = Math.max(maxDisc, setDisc);
        return maxDisc && BUNDLE_CODES[String(maxDisc)] ? { percent: maxDisc, code: BUNDLE_CODES[String(maxDisc)] } : null;
    }

    function inr(cents) {
        return '₹' + (cents / 100).toLocaleString('en-IN');
    }

    window.zlpOpenCart = function () {
        if (!drawer) return;
        drawer.classList.add('open');
        overlay.classList.add('open');
        document.body.style.overflow = 'hidden';
        refreshCart();
    };
    window.zlpCloseCart = function () {
        if (!drawer) return;
        drawer.classList.remove('open');
        overlay.classList.remove('open');
        document.body.style.overflow = '';
    };

    document.querySelectorAll('[data-cart-open]').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
            e.preventDefault();
            window.zlpOpenCart();
        });
    });
    document.querySelectorAll('[data-cart-close]').forEach(function (btn) {
        btn.addEventListener('click', window.zlpCloseCart);
    });
    if (overlay) overlay.addEventListener('click', window.zlpCloseCart);

    function updateHeaderCount(count) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
            el.textContent = count;
            el.style.display = count > 0 ? 'grid' : 'none';
        });
    }

    function renderItems(cart) {
        var wrap = document.getElementById('CartDrawerItems');
        if (!wrap) return;
        if (!cart.items.length) {
            wrap.innerHTML =
                '<div class="grid h-full place-items-center"><p class="font-mono-zlp text-xs uppercase tracking-[0.25em] text-zinc-500">' + EMPTY_TEXT + '</p></div>';
            return;
        }
        wrap.innerHTML = cart.items
            .map(function (item, i) {
                var line = i + 1;
                var img = item.image
                    ? '<img src="' + item.image + '" alt="" class="h-24 w-20 object-cover">'
                    : '<div class="h-24 w-20 bg-[#18181F]"></div>';
                return (
                    '<li class="flex gap-4 border border-white/10 bg-[#121216] p-3">' +
                    img +
                    '<div class="flex flex-1 flex-col justify-between py-1">' +
                    '<div><p class="font-display text-[11px] font-bold uppercase leading-tight">' + item.product_title + '</p>' +
                    '<p class="mt-1 font-mono-zlp text-[10px] uppercase tracking-[0.2em] text-zinc-500">' + (item.variant_title || '') + '</p>' +
                    (item.properties
                        ? Object.keys(item.properties)
                              .filter(function (k) { return item.properties[k]; })
                              .map(function (k) {
                                  return '<p class="mt-1 font-mono-zlp text-[10px] font-bold uppercase tracking-[0.15em] text-[var(--zlp-volt)]">' + k + ': ' + item.properties[k] + '</p>';
                              })
                              .join('')
                        : '') +
                    '</div>' +
                    '<div class="flex items-center justify-between">' +
                    '<div class="flex items-center border border-white/15">' +
                    '<button data-line="' + line + ':' + (item.quantity - 1) + '" class="grid h-7 w-7 place-items-center text-zinc-400 hover:text-[var(--zlp-volt)]">−</button>' +
                    '<span class="w-8 text-center font-mono-zlp text-xs">' + item.quantity + '</span>' +
                    '<button data-line="' + line + ':' + (item.quantity + 1) + '" class="grid h-7 w-7 place-items-center text-zinc-400 hover:text-[var(--zlp-volt)]">+</button>' +
                    '</div>' +
                    '<p class="font-display text-xs font-bold text-[var(--zlp-volt)]">' + inr(item.final_line_price) + '</p>' +
                    '</div></div>' +
                    '<button data-line="' + line + ':0" class="self-start p-1 text-zinc-600 transition-colors hover:text-[var(--zlp-pink)]">✕</button>' +
                    '</li>'
                );
            })
            .join('');

        wrap.querySelectorAll('[data-line]').forEach(function (btn) {
            btn.addEventListener('click', function () {
                var attr = btn.getAttribute('data-line');
                var idx = attr.lastIndexOf(':');
                changeQty(parseInt(attr.substring(0, idx), 10), parseInt(attr.substring(idx + 1), 10));
            });
        });
    }

    function renderFooter(cart) {
        var footer = document.getElementById('CartDrawerFooter');
        if (!footer) return;
        if (!cart.items.length) {
            footer.classList.add('hidden');
            return;
        }
        footer.classList.remove('hidden');
        var msg = document.getElementById('ShipMsg');
        var bar = document.getElementById('ShipBar');
        var sub = document.getElementById('CartSubtotal');
        var ship = document.getElementById('CartShipping');
        if (sub) sub.textContent = inr(cart.total_price);
        if (cart.total_price >= FREE_SHIP) {
            if (msg) msg.textContent = 'Free shipping unlocked';
            if (ship) ship.textContent = 'FREE';
        } else {
            if (msg) msg.textContent = inr(FREE_SHIP - cart.total_price) + ' away from free shipping';
            if (ship) ship.textContent = 'At checkout';
        }
        if (bar) bar.style.width = Math.min(100, (cart.total_price / FREE_SHIP) * 100) + '%';

        var bundle = bundleDiscountCode(cart);
        var checkoutBtn = document.getElementById('CartCheckoutBtn');
        var codeMsg = document.getElementById('BundleCodeMsg');
        if (checkoutBtn) {
            checkoutBtn.href = bundle ? '/discount/' + encodeURIComponent(bundle.code) + '?redirect=/checkout' : '/checkout';
        }
        if (codeMsg) {
            if (bundle) {
                codeMsg.textContent = 'Bundle discount ' + bundle.percent + '% auto-applied at checkout (' + bundle.code + ')';
                codeMsg.classList.remove('hidden');
            } else {
                codeMsg.classList.add('hidden');
            }
        }
    }

    function refreshCart() {
        fetch('/cart.js')
            .then(function (r) { return r.json(); })
            .then(function (cart) {
                updateHeaderCount(cart.item_count);
                renderItems(cart);
                renderFooter(cart);
            })
            .catch(function () {});
    }

    function changeQty(line, qty) {
        return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ line: line, quantity: qty }),
        })
            .then(function (r) { return r.json(); })
            .then(function (cart) {
                if (!cart || typeof cart.item_count === 'undefined') return;
                updateHeaderCount(cart.item_count);
                renderItems(cart);
                renderFooter(cart);
            })
            .catch(function () {});
    }

    window.zlpAddToCart = function (variantId, qty, openDrawer) {
        return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: qty || 1 }] }),
        })
            .then(function (r) { return r.json(); })
            .then(function () {
                refreshCart();
                if (openDrawer !== false) window.zlpOpenCart();
            });
    };

    window.zlpChangeQty = changeQty;
    window.zlpBundleCode = bundleDiscountCode;

    refreshCart();
})();
